var formTokenManager = (function () {
    var config = {
        tokenFieldName: "__RequestVerificationToken",
        apiEndpoint: "/api/forms/GetAntiforgeryToken"
    };

    function formTokenManager() { }

    formTokenManager.prototype.init = function () {
        var self = this;
        if (document.getElementsByName(config.tokenFieldName).length > 0) {
            self.fetchToken();
        }
    };

    formTokenManager.prototype.fetchToken = function () {
        var self = this;
        fetch(config.apiEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (res) {
                return res.json();
            })
            .then(function (data) {
                self.updateTokenField(data.Value);
            })
            .catch(function (err) {
                //console.error("Error fetching the token:", err);
            });
    };

    formTokenManager.prototype.updateTokenField = function (tokenValue) {
        var tokenElements = document.getElementsByName(config.tokenFieldName);
        if (tokenElements.length > 0) {
            for (var i = 0; i < tokenElements.length; i++) {
                tokenElements[i].value = tokenValue;
            }
        }
    };

    return formTokenManager;
})();

$(document).ready(function () {
    var tokenManager = new formTokenManager();
    tokenManager.init();
});
